"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var remote_container_1 = __importDefault(require("./remote-container"));

var capsule_1 = __importDefault(require("../capsule"));

var memfs_1 = require("memfs");

var deserialize_error_1 = __importDefault(require("deserialize-error"));

var Shell;

(function (Shell) {
  Shell["Shell"] = "/bin/sh";
  Shell["Bash"] = "/bin/bash";
})(Shell = exports.Shell || (exports.Shell = {}));

function factory(remoteOptions, options) {
  var x = {
    createContainer: function x() {
      var container = new remote_container_1.default(remoteOptions);
      return Promise.resolve(container);
    }
  };
  return x;
}

exports.factory = factory;

var RemoteCapsule = function (_super) {
  __extends(RemoteCapsule, _super);

  function RemoteCapsule(container, fs, console, state) {
    var _this = _super.call(this, container, fs, console, state) || this;

    _this.container = container;
    _this.fs = fs;
    _this.console = console;
    _this.state = state;
    _this.socket = undefined;
    _this.socket = container.socket;
    return _this;
  }

  Object.defineProperty(RemoteCapsule.prototype, "url", {
    get: function get() {
      return this.container.url;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RemoteCapsule.prototype, "connectionState", {
    get: function get() {
      return this.container.state;
    },
    enumerable: true,
    configurable: true
  });

  RemoteCapsule.prototype.start = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        _super.prototype.start.call(this);

        return [2];
      });
    });
  };

  RemoteCapsule.prototype.disconnect = function () {
    if (!this.socket) return;
    return this.socket.disconnect();
  };

  RemoteCapsule.prototype.installPackages = function (packages, authorizationToken) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      console.log("call installing packages", packages);
      if (!_this.socket) return;

      _this.socket.emit("installPackages", {
        packageNames: packages
      }, authorizationToken);

      _this.socket.on("packagesInstalled", function (data) {
        resolve(data);
      });
    });
  };

  RemoteCapsule.prototype.build = function (options) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      console.log("call build ");
      if (!_this.socket) return;

      _this.socket.emit("build", options);

      _this.socket.on("buildDone", function (output) {
        return resolve(output);
      });

      _this.socket.on("buildError", function (error) {
        var err = deserialize_error_1.default(error);
        return reject(err);
      });
    });
  };

  RemoteCapsule.prototype.download = function (options) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      console.log("call fetch ");
      if (!_this.socket) return;

      _this.socket.emit("download", options);

      _this.socket.on("downloadDone", function (data) {
        return resolve(data);
      });

      _this.socket.on("downloadError", function (error) {
        return reject(deserialize_error_1.default(error));
      });
    });
  };

  RemoteCapsule.prototype.installPackagesAndWriteFile = function (files, authorizationToken) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      _this.container.setLastUsed();

      console.log("installing packages and write files", Object.keys(files));
      if (!_this.socket) return;

      _this.socket.emit("installPackagesAndWriteFs", files, authorizationToken);

      _this.socket.on("packagesInstalledAndFileWrote", function (res) {
        var parsedRes = res;

        if (res.error) {
          parsedRes.error = res.error;
        }

        console.log("finish installing packages and write files", Object.keys(files), res);
        resolve(res);
      });
    });
  };

  RemoteCapsule.prototype.onInstallation = function (cb) {
    if (!this.socket) return;
    this.socket.on("installingPackages", function (packages) {
      console.log("installing packages", packages);
      cb("start", packages);
    });
    this.socket.on("packagesInstalled", function (packages) {
      console.log("installed packages", packages);
      cb("end", packages);
    });
  };

  RemoteCapsule.prototype.terminal = function (shell, tty) {
    if (shell === void 0) {
      shell = Shell.Shell;
    }

    if (tty === void 0) {
      tty = true;
    }

    return this.exec({
      command: [Shell.Shell],
      tty: tty
    });
  };

  return RemoteCapsule;
}(capsule_1.default);

exports.RemoteCapsule = RemoteCapsule;

exports.default = function (remoteCapsuleOptions, vol) {
  if (remoteCapsuleOptions === void 0) {
    remoteCapsuleOptions = {};
  }

  return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, RemoteCapsule.create(factory(remoteCapsuleOptions), vol ? vol : new memfs_1.Volume())];

        case 1:
          return [2, _a.sent()];
      }
    });
  });
};